import { createLazyFileRoute, Outlet } from "@tanstack/react-router";
import { memo } from "react";

import { BoardPage } from "@/features/board/routes/Board";
import { NavStackProvider } from "@/utils/useNavStack";

export const Route = createLazyFileRoute("/_auth/_app/board")({
  component: memo(() => (
    <NavStackProvider label="Board" href={{ to: "/board" }}>
      <BoardPage />
      <Outlet />
    </NavStackProvider>
  )),
});
